import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "../UI elements/Pagination";
import { TextField } from "@mui/material";
import AddbtnIcon from "../../../../../Assets/Icons/btn-add-white.svg";
import Bride from "../../../../../Assets/Images/Lonely bride.svg";
import IOSSwitch from "../UI elements/iOSswitch";
import CategoriesTableRow from "../UI elements/CategoriesTableRow";
import axiosInstance from "../../../../../axiosInstance";

const Categories = (props) => {
  const [Users, setUsers] = useState([]);
  const [Pages, setPages] = useState([1]);
  const [UserToEdit, setUserToEdit] = useState();
  const [PageInfo, setPageInfo] = useState({
    FirstPage: 1,
    FirstDotsShown: false,
    MiddlePage: 3,
    LastDotsShown: false,
    LastPage: 7,
    ActivePage: 1,
  });
  const [SelectedSize, setSelectedSize] = useState(5);
  const [TotalElements, setTotalElements] = useState(10);
  const [ResultIsEmpty, setResultIsEmpty] = useState(false);
  const [AddIsOpen, setaddIsOpen] = useState(false);
  const [SelectedProfiles, setSelectedProfiles] = useState([]);
  const [ActiveSort, setActiveSort] = useState({
    type: "firstName",
    direction: "asc",
  });
  const [EditUserIsOpen, setEditUserIsOpen] = useState(false);
  const [ChangesMade, setChangesMade] = useState(false);
  const [SelectedStart, setSelectedStart] = useState(0);
  const [NewCategory, setNewCategory] = useState({
    name: "",
    modelName: "",
    visibility: true,
  });
  const [NameValidation, setNameValidation] = useState({
    hasError: false,
    errorText: "Title is mandatory",
  });
  const [ModelNameValidation, setModelNameValidation] = useState({
    hasError: false,
    errorText: "Model is mandatory",
  });
  const [ItemToEdit, setItemToEdit] = useState();
  const [ErrorRowIndex, setErrorRowIndex] = useState();

  useEffect(() => {
    getFilteredData(1, 5, "firstName,asc", undefined, undefined);
  }, []);

  const getFilteredData = (PageNumber, Size) => {
    if (!Size) {
      Size = SelectedSize;
    }

    let ReqURL =
      window.localStorage.getItem("BaseURL") +
      "/services/projectmanagement/api/categories?page=" +
      parseInt(PageNumber - 1) +
      "&size=" +
      Size;

    if (document.getElementById("search-input").value.length > 0) {
      ReqURL =
        ReqURL + "&search=" + document.getElementById("search-input").value;
    }

    setSelectedStart(PageNumber);

    let Req = {
      method: "GET",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        setTotalElements(Res.headers["x-total-count"]);
        createPagination(Res.headers["x-total-count"]);

        if (Res.data.length === 0) {
          setResultIsEmpty(true);
        } else {
          setResultIsEmpty(false);
        }

        setTimeout(() => {
          if (PageNumber === 1 && document.getElementById("1-page-btn")) {
            updatePaginationActiveClass(1);
          }
          if (document.getElementById("1-page-btn") && Size !== SelectedSize) {
            document.getElementById("1-page-btn").click();
          }
        }, 500);
        setUsers(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const createPagination = (TotalCount) => {
    let Size = parseInt(SelectedSize);
    let Count = Math.ceil(TotalCount / Size);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };

  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    if (document.getElementById(PageNumber + "-page-btn") !== null) {
      if (PageNumber === 3) {
        document.getElementById(3 + "-page-btn").classList.add("active-page");
      } else {
        document
          .getElementById(PageNumber + "-page-btn")
          .classList.add("active-page");
      }
    }
  };

  const toggleEditCategory = (Item) => {
    setItemToEdit({ ...Item, visibility: true });
    setaddIsOpen(false);
    setEditUserIsOpen(true);
  };

  const saveData = () => {
    if (EditUserIsOpen) {
      let Req = {
        method: "PUT",
        baseURL:
          window.localStorage.getItem("BaseURL") +
          "/services/projectmanagement/api/categories/" +
          ItemToEdit.id,
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
        },
        data: {
          id: ItemToEdit.id,
          name: ItemToEdit.name,
          modelName: ItemToEdit.modelName,
          enabled: ItemToEdit.enabled,
        },
      };
      axiosInstance(Req)
        .then((Res) => {
          console.log(Res);
          setChangesMade(false);
          getFilteredData(
            1,
            SelectedSize,
            "firstName,asc",
            undefined,
            undefined
          );
        })
        .catch((Err) => {
          console.log(Err);
          if (Err.response.status === 400) {
            setNameValidation({
              hasError: true,
              errorText: "A category with this name already exists",
            });
          }
        });
    } else {
      let Req = {
        method: "POST",
        baseURL:
          window.localStorage.getItem("BaseURL") +
          "/services/projectmanagement/api/categories",
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
        },
        data: {
          name: NewCategory.name,
          modelName: NewCategory.modelName,
          enabled: NewCategory.visibility,
        },
      };
      axiosInstance(Req)
        .then((Res) => {
          console.log(Res);
          setChangesMade(false);
          getFilteredData(
            1,
            SelectedSize,
            "firstName,asc",
            undefined,
            undefined
          );
        })
        .catch((Err) => {
          console.log(Err);
          if (Err.response.status === 400) {
            setNameValidation({
              hasError: true,
              errorText: "A category with this name already exists",
            });
          }
        });
    }
  };

  const handleEditNameChange = (e) => {
    if (e.target.value.trim()) {
      setChangesMade(true);
      setNameValidation({ hasError: false, errorText: "" });
    } else {
      setChangesMade(false);
      setNameValidation({ hasError: true, errorText: "Title is mandatory" });
    }
    setItemToEdit({ ...ItemToEdit, name: e.target.value });
  };
  const handleEditModelNameChange = (e) => {
    if (e.target.value.trim()) {
      setChangesMade(true);
      setModelNameValidation({ hasError: false, errorText: "" });
    } else {
      setChangesMade(false);
      setModelNameValidation({
        hasError: true,
        errorText: "Model is mandatory",
      });
    }
    setItemToEdit({ ...ItemToEdit, modelName: e.target.value });
  };
  const handleNewCatNameChange = (e) => {
    if (e.target.value.trim()) {
      setChangesMade(true);
      setNameValidation({ hasError: false, errorText: "" });
    } else {
      setChangesMade(false);
      setNameValidation({ hasError: true, errorText: "Title is mandatory" });
    }
    setNewCategory({ ...NewCategory, name: e.target.value });
  };
  const handleNewCatModelNameChange = (e) => {
    if (e.target.value.trim()) {
      setChangesMade(true);
      setModelNameValidation({ hasError: false, errorText: "" });
    } else {
      setChangesMade(false);
      setModelNameValidation({
        hasError: true,
        errorText: "Model is mandatory",
      });
    }
    setNewCategory({ ...NewCategory, modelName: e.target.value });
  };
  const handleActivationChange = (e) => {
    setItemToEdit({ ...ItemToEdit, enabled: e.target.checked });
    setChangesMade(true);
  };
  const handleNewCatVisibility = (e) => {
    setChangesMade(true);
    setNewCategory({ ...NewCategory, visibility: e.target.checked });
  };
  const handlePaginationSizeChange = (NewSize) => {
    setSelectedSize(NewSize);
    getFilteredData(1, NewSize, "firstName,asc", undefined, undefined);
  };

  const requestPageNumber = (PageNumber) => {
    updatePaginationActiveClass(PageNumber);
    getFilteredData(PageNumber);
    if (PageNumber === 1) {
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    } else {
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === Pages.length) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
    } else {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
    }
  };

  const updatePaginationActiveClass = (CurrentId) => {
    Pages.map((Page) => {
      if (document.getElementById(Page + "-page-btn")) {
        document
          .getElementById(Page + "-page-btn")
          .classList.remove("active-page");
      }
    });
    document
      .getElementById(CurrentId + "-page-btn")
      .classList.add("active-page");
  };

  const toggleDeleteCategory = (CatId, RequestedItemIndex) => {
    let Req = {
      method: "DELETE",
      baseURL:
        window.localStorage.getItem("BaseURL") +
        "/services/projectmanagement/api/categories/" +
        CatId,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        getFilteredData(
          1,
          SelectedSize,
          ActiveSort.type === "nameLike"
            ? ActiveSort.type + "," + ActiveSort.direction
            : undefined,
          undefined,
          undefined
        );
      })
      .catch((Err) => {
        console.log(Err);
        if ((Err.response.data.message = "error.categoryinuse")) {
          setErrorRowIndex(RequestedItemIndex);

          setTimeout(() => {
            setErrorRowIndex(undefined);
          }, 10000);
        }
      });
  };

  const toggleCancel = () => {
    setChangesMade(false);
    setNameValidation({ hasError: false, errorText: "" });
    setModelNameValidation({ hasError: false, errorText: "" });

    if (EditUserIsOpen) {
      setEditUserIsOpen(false);
    } else {
      setaddIsOpen(false);
    }

    getFilteredData(1);
  };

  const toggleAddCategory = () => {
    setNameValidation({
      hasError: false,
      errorText: "",
    });
    setaddIsOpen(true);
    setNewCategory({ ...NewCategory, name: "" });
  };

  return (
    <div className="form-wrapper two-column-table">
      {EditUserIsOpen || AddIsOpen ? null : (
        <a className="add-trigger" onClick={() => toggleAddCategory()}>
          <img alt="+" src={AddbtnIcon} />
          New Category
        </a>
      )}
      <section className="form-head">
        {EditUserIsOpen || AddIsOpen ? (
          <>
            <i
              onClick={() => toggleCancel()}
              className="feather-arrow-left arrow-back"
            ></i>
            <h1 className="head-title">Back to the categories</h1>
            <section className="head-actions">
              <span
                onClick={() => toggleCancel()}
                className="action-btn cancel"
              >
                <Link>Cancel</Link>
              </span>
              <span
                className={
                  ChangesMade &&
                  document.getElementById("title").value.length > 0 &&
                  document.getElementById("model").value.length > 0
                    ? "action-btn save"
                    : "action-btn save disabled"
                }
                onClick={() => saveData()}
              >
                Save
              </span>
            </section>
          </>
        ) : (
          <>
            {" "}
            <div className="table-filter large">Title</div>
            <div className="table-filter medium">Visibility</div>
          </>
        )}
      </section>

      {EditUserIsOpen ? (
        <div className="table-body">
          <section className="top-section" style={{ borderBottom: "none" }}>
            <p className="section-label">Category settings</p>
            <section className="section-row">
              <p className="row-name">
                Title<p className="mandatory">*</p>
              </p>
              <TextField
                autoComplete="off" // Disable autofill
                fullWidth
                id="title"
                name="title"
                label={"Title"}
                placeholder={""}
                required
                variant="outlined"
                value={ItemToEdit.name}
                error={NameValidation.hasError}
                helperText={NameValidation.errorText}
                onChange={handleEditNameChange}
                margin="normal"
                sx={{
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "#FB4764", // Change border color when focused
                    },
                  backgroundColor: "transparent",
                  borderRadius: "4px",
                  width: "400px",
                  borderBottom: "none",
                }}
              />
            </section>
            <section className="section-row">
              <p className="row-name">
                AI Model Name<p className="mandatory">*</p>
              </p>
              <TextField
                autoComplete="off" // Disable autofill
                fullWidth
                id="model"
                name="model"
                label={"Model"}
                placeholder={""}
                required
                variant="outlined"
                value={ItemToEdit.modelName}
                error={ModelNameValidation.hasError}
                helperText={ModelNameValidation.errorText}
                onChange={handleEditModelNameChange}
                margin="normal"
                sx={{
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "#FB4764", // Change border color when focused
                    },
                  backgroundColor: "transparent",
                  borderRadius: "4px",
                  width: "400px",
                  borderBottom: "none",
                }}
              />
            </section>
            <section className="section-row">
              <span className="row-name">
                Visibility<p className="mandatory">*</p>
              </span>
              <IOSSwitch
                checked={ItemToEdit.enabled}
                onChange={handleActivationChange}
              />
            </section>
          </section>
        </div>
      ) : (
        <>
          {AddIsOpen ? (
            <div className="table-body">
              <section className="top-section" style={{ borderBottom: "none" }}>
                <p className="section-label">Category settings</p>
                <section className="section-row">
                  <p className="row-name">
                    Title<p className="mandatory">*</p>
                  </p>
                  <TextField
                    autoComplete="off" // Disable autofill
                    fullWidth
                    id="title"
                    name="title"
                    label={"Title"}
                    placeholder={""}
                    error={NameValidation.hasError}
                    helperText={NameValidation.errorText}
                    required
                    variant="outlined"
                    value={NewCategory.name}
                    onChange={handleNewCatNameChange}
                    margin="normal"
                    sx={{
                      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor: "#FB4764", // Change border color when focused
                        },
                      backgroundColor: "transparent",
                      borderRadius: "4px",
                      width: "400px",
                      borderBottom: "none",
                    }}
                  />
                </section>
                <section className="section-row">
                  <p className="row-name">
                    AI Model Name<p className="mandatory">*</p>
                  </p>
                  <TextField
                    autoComplete="off" // Disable autofill
                    fullWidth
                    id="model"
                    name="model"
                    label={"Model"}
                    placeholder={""}
                    required
                    variant="outlined"
                    value={NewCategory.modelName}
                    error={ModelNameValidation.hasError}
                    helperText={ModelNameValidation.errorText}
                    onChange={handleNewCatModelNameChange}
                    margin="normal"
                    sx={{
                      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor: "#FB4764", // Change border color when focused
                        },
                      backgroundColor: "transparent",
                      borderRadius: "4px",
                      width: "400px",
                      borderBottom: "none",
                    }}
                  />
                </section>
                <section className="section-row">
                  <span className="row-name">
                    Visibility<p className="mandatory">*</p>
                  </span>
                  <IOSSwitch
                    checked={NewCategory.visibility}
                    onChange={handleNewCatVisibility}
                  />
                </section>
              </section>
            </div>
          ) : (
            <>
              <div className="table-body">
                {ResultIsEmpty ? (
                  <div className="empty-state">
                    <img alt="" src={Bride} />
                    <h1>No results found</h1>
                  </div>
                ) : (
                  <>
                    {Users.map((Item, i) => (
                      <CategoriesTableRow
                        key={i}
                        Item={Item}
                        Index={i}
                        ErrorRowIndex={ErrorRowIndex}
                        EditCategory={() => {
                          toggleEditCategory(Item);
                        }}
                        ToggleDeleteUser={(UserId) =>
                          toggleDeleteCategory(UserId, i)
                        }
                      />
                    ))}
                  </>
                )}
              </div>
              {ErrorRowIndex ? (
                <p class="error-text">
                  {
                    "The category cannot be deleted as it has already been assigned to a product (image)."
                  }
                </p>
              ) : null}

              {ResultIsEmpty ? null : (
                <Pagination
                  Pages={Pages}
                  PageInfo={PageInfo}
                  SelectedSize={SelectedSize}
                  SelectedStart={SelectedStart}
                  TotalElements={TotalElements}
                  SelectedProfiles={SelectedProfiles}
                  DeselectCheckboxes={null}
                  RequestPageNumber={(PageNum) => requestPageNumber(PageNum)}
                  setSelectedSize={(Size) => handlePaginationSizeChange(Size)}
                />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Categories;
